import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 14",
  stroke: "white"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M3.87501 3.56262H9.96879C11.2855 3.56262 11.9438 3.56262 12.4167 3.87863C12.6215 4.01544 12.7973 4.19123 12.9341 4.39597C13.1967 4.78903 13.241 5.4181 13.2485 6.37526M7.00003 3.56262L6.60413 2.77079C6.27614 2.11479 5.97641 1.45447 5.24956 1.18189C4.9312 1.0625 4.56753 1.0625 3.84018 1.0625C2.70488 1.0625 2.13723 1.0625 1.71129 1.30021C1.40767 1.46966 1.15714 1.7202 0.987699 2.02384C0.75 2.4498 0.75 3.01747 0.75 4.15282V6.06275C0.75 9.00917 0.75 10.4824 1.6653 11.3977C2.47788 12.2103 3.73014 12.3015 6.06252 12.3118",
      fill: "none",
      "stroke-width": "1.2",
      "stroke-linecap": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M8.33366 7.96712C8.97538 7.3254 9.29624 7.00454 9.6764 6.91327C9.88911 6.8622 10.1109 6.8622 10.3236 6.91327C10.7038 7.00454 11.0246 7.3254 11.6663 7.96712C12.3081 8.60885 12.6289 8.92971 12.7202 9.30986C12.7713 9.52257 12.7713 9.74435 12.7202 9.95707C12.6289 10.3372 12.3081 10.6581 11.6663 11.2998C11.0246 11.9415 10.7038 12.2624 10.3236 12.3537C10.1109 12.4047 9.88911 12.4047 9.67639 12.3537C9.29624 12.2624 8.97538 11.9415 8.33366 11.2998C7.69194 10.6581 7.37107 10.3372 7.27981 9.95707C7.22874 9.74435 7.22874 9.52257 7.27981 9.30986C7.37107 8.92971 7.69194 8.60885 8.33366 7.96712Z",
      fill: "none"
    }, null, -1)
  ]))]))
}
export default { render: render }